// Words for campaigns, shared by the list and the editor.
import type { Campaign, CampaignStatus } from '../api/campaigns'

export const campaignStatusLabel: Record<CampaignStatus, string> = {
  draft: 'Draft',
  scheduled: 'Scheduled',
  sending: 'Sending',
  done: 'Finished',
  cancelled: 'Cancelled',
}

export const campaignStatusVariant: Record<CampaignStatus, 'success' | 'attention' | 'neutral' | 'outline'> = {
  draft: 'neutral',
  scheduled: 'outline',
  sending: 'attention',
  done: 'success',
  cancelled: 'neutral',
}

export function audienceSummary(c: Pick<Campaign, 'includeTags' | 'excludeTags'>): string {
  const names = (tags: { name: string }[]) => tags.map((t) => t.name).join(', ')
  const who = c.includeTags.length === 0 ? 'Every contact' : `Tagged ${names(c.includeTags)}`
  return c.excludeTags.length === 0 ? who : `${who}, except ${names(c.excludeTags)}`
}
